// ============================================
// Google Ads Reklam Ajansı - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const googleAdsReklamAjansiContent: BlogContent = {
  tableOfContents: [
    { id: "ajans-secimi", title: "Profesyonel Ajans Seçimi" },
    { id: "hizmet-paketleri", title: "Hizmet Paketleri ve Fiyatlandırma" },
    { id: "sozlesme-kosullari", title: "Sözleşme Koşulları" },
    { id: "roi-beklentisi", title: "ROI Beklentileri ve Performans" },
    { id: "tehlikeli-ajanslar", title: "Kaçınılması Gereken Ajanslar" },
    { id: "baslangic-sureci", title: "Başlangıç Süreci" }
  ],
  content: [
    {
      type: "paragraph",
      value: "<strong>Google reklam ajansı</strong> seçimi, dijital pazarlama başarınızın temelidir. Yanlış seçim bütçenizi çarçur edebilir. <a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">Google Reklam Ajansı</a> ile doğru ajans seçimi, hizmet paketleri, sözleşme şartları ve ROI beklentileri hakkında kapsamlı rehberinizi hazırladım."
    },
    { type: "heading", value: "Google Ads Reklam Ajansı Seçiminde 15 Kritik Kriter", id: "ajans-secimi" },
    {
      type: "paragraph",
      value: "Doğru Google Ads reklam ajansı seçmek için aşağıdaki kriterleri mutlaka değerlendirmelisiniz. <a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">Dijital Mustafa</a> gördüğüm en önemli kriterler bunlardır."
    },
    {
      type: "subheading",
      value: "1. Google Partner ve Premier Partner Statüsü"
    },
    {
      type: "list",
      items: [
        "<strong>Google Partner Badge:</strong> Ajansın resmi Google Partner olup olmadığını kontrol edin",
        "<strong>Premier Partner:</strong> Daha yüksek standardı karşılayan Premier Partner statüsü tercih edilir",
        "<strong>Specialization Badges:</strong> Search, Display, Video, Shopping uzmanlık rozetlerini kontrol edin",
        "<strong>Minimum Spend Requirement:</strong> Google Partner olmak için yıllık $10,000+ ad spend yönetimi gerekir",
        "<strong>Performance Requirements:</strong> %70+ optimization score ve %50+ retention rate şartı",
        "<strong>Certification Requirements:</strong> En az 1 Google Ads certified professional gereklidir"
      ]
    },
    {
      type: "paragraph",
      value: "<strong>Önemli:</strong> Google Partner badge'i olan her ajans otomatik olarak iyi değildir, ama badge olmaması genellikle ciddi bir red flag'dir."
    },
    {
      type: "subheading",
      value: "2. Sektör Deneyimi ve Case Study'ler"
    },
    {
      type: "list",
      items: [
        "<strong>Sektör Tecrübesi:</strong> Sizin sektörünüzde (e-ticaret, B2B, healthcare, vb.) en az 3 yıl deneyim",
        "<strong>Kanıtlanmış Sonuçlar:</strong> Benzer bütçedeki müşteriler için case study'ler",
        "<strong>Performans Metrikleri:</strong> ROAS, CPA, conversion rate gibi net metrikler",
        "<strong>Referanslar:</strong> Mevcut veya geçmiş müşterilerle görüşme imkanı",
        "<strong>Portfolio:</strong> Yönetilen kampanya örnekleri ve başarı hikayeleri"
      ]
    },
    {
      type: "subheading",
      value: "3. Ekip Yapısı ve Expertise"
    },
    {
      type: "list",
      items: [
        "<strong>Dedicated Account Manager:</strong> Size özel bir hesap yöneticisi atanacak mı?",
        "<strong>Deneyim Seviyesi:</strong> Hesabınızı yönetecek kişinin tecrübesi (5+ yıl ideal)",
        "<strong>Ekip Derinliği:</strong> Specialist ekipler var mı? (Search, Display, Video uzmanları)",
        "<strong>Turnover Rate:</strong> Account manager değişim sıklığı (düşük olmalı)",
        "<strong>Training & Development:</strong> Ekip sürekli eğitim alıyor mu?"
      ]
    },
    {
      type: "subheading",
      value: "4. Şeffaflık ve İletişim"
    },
    {
      type: "list",
      items: [
        "<strong>Hesap Erişimi:</strong> Google Ads hesabının admin erişimi size ait olacak mı? (Mutlaka EVET olmalı)",
        "<strong>Raporlama:</strong> Haftalık mı aylık mı? Hangi metrikleri raporlarlar?",
        "<strong>Communication Channels:</strong> Telefon, email, WhatsApp, Slack - nasıl iletişim kuracaksınız?",
        "<strong>Response Time:</strong> Sorularınıza ne kadar sürede yanıt alırsınız? (24 saat ideal)",
        "<strong>Transparency:</strong> Tüm kampanya detaylarını görebiliyor musunuz?"
      ]
    },
    {
      type: "subheading",
      value: "5. Teknoloji ve Araçlar"
    },
    {
      type: "list",
      items: [
        "<strong>Analytics Setup:</strong> Google Analytics 4, Google Tag Manager kurulumu ve yönetimi",
        "<strong>Automation:</strong> Google Ads scripts, rules, automated bidding expertise",
        "<strong>Reporting Tools:</strong> Looker Studio (Data Studio), Supermetrics, custom dashboards",
        "<strong>A/B Testing:</strong> Google Optimize, VWO veya benzeri araçlar",
        "<strong>CRO Tools:</strong> Hotjar, Crazy Egg gibi conversion optimization araçları",
        "<strong>Competitive Intelligence:</strong> SEMrush, SpyFu, Auction Insights analizi"
      ]
    },
    {
      type: "subheading",
      value: "6. Strateji ve Yaklaşım"
    },
    {
      type: "list",
      items: [
        "<strong>Customization:</strong> Şablonlu yaklaşım mı yoksa özelleştirilmiş strateji mi?",
        "<strong>Testing Methodology:</strong> Sürekli A/B testing ve optimization kültürü var mı?",
        "<strong>Data-Driven:</strong> Kararlar veri analizine mi dayalı yoksa varsayımlara mı?",
        "<strong>Long-term Vision:</strong> Kısa vadeli taktikler mi yoksa uzun vadeli strateji mi?",
        "<strong>Innovation:</strong> Yeni Google Ads özelliklerini ne kadar hızlı adapte ediyorlar?"
      ]
    },
    { type: "heading", value: "Hizmet Paketleri ve Detaylı Fiyatlandırma", id: "hizmet-paketleri" },
    {
      type: "paragraph",
      value: "Google Ads reklam ajansları genellikle farklı hizmet paketleri sunar. İşte 2025 Türkiye piyasası standart paketleri ve fiyatlandırması:"
    },
    {
      type: "table",
      caption: "Google Ads Ajansı Hizmet Paketleri ve Fiyatlandırma (2025)",
      headers: ["Paket", "Aylık Reklam Bütçesi", "Aylık Yönetim Ücreti", "Hizmet Kapsamı", "İletişim"],
      rows: [
        [
          "<strong>Başlangıç</strong>",
          "15.000-30.000₺",
          "12.000-15.000₺",
          "1-2 kampanya, temel optimizasyon, aylık rapor",
          "Email"
        ],
        [
          "<strong>Standart</strong>",
          "30.000-75.000₺",
          "15.000-22.000₺",
          "3-5 kampanya, ileri optimizasyon, haftalık rapor",
          "Email + Telefon"
        ],
        [
          "<strong>Profesyonel</strong>",
          "75.000-150.000₺",
          "22.000-35.000₺",
          "Tüm kampanyalar, CRO, remarketing, iki haftalık rapor",
          "Dedicated manager"
        ],
        [
          "<strong>Premium</strong>",
          "150.000-300.000₺",
          "35.000-50.000₺",
          "Full-service, özel strateji, haftalık toplantı",
          "24/7 destek"
        ],
        [
          "<strong>Enterprise</strong>",
          "300.000₺+",
          "50.000₺+",
          "Multi-channel, Google rep access, real-time reporting",
          "Dedicated team"
        ]
      ]
    },
    {
      type: "subheading",
      value: "Başlangıç Paketi Detayları (15.000-30.000₺ Bütçe)"
    },
    {
      type: "list",
      items: [
        "<strong>Kurulum:</strong> Google Ads hesabı kurulumu (yeni hesap için)",
        "<strong>Kampanya Sayısı:</strong> 1-2 kampanya (Search veya Shopping)",
        "<strong>Keyword Research:</strong> 50-100 anahtar kelime araştırması",
        "<strong>Ad Copy:</strong> 10-15 reklam metni oluşturma",
        "<strong>Optimization:</strong> Haftalık performans takibi, aylık optimizasyon",
        "<strong>Reporting:</strong> Aylık performans raporu",
        "<strong>İletişim:</strong> Email ile iletişim, 48 saat response time",
        "<strong>Süre:</strong> Minimum 3 ay sözleşme"
      ]
    },
    {
      type: "subheading",
      value: "Standart Paket Detayları (30.000-75.000₺ Bütçe)"
    },
    {
      type: "list",
      items: [
        "<strong>Kurulum:</strong> Tam hesap audit + kurulum",
        "<strong>Kampanya Sayısı:</strong> 3-5 kampanya (Search, Display, Shopping)",
        "<strong>Keyword Research:</strong> 100-300 anahtar kelime + negatif keywords",
        "<strong>Ad Copy:</strong> 20-30 reklam metni + A/B testing",
        "<strong>Landing Pages:</strong> Landing page önerileri ve iyileştirmeler",
        "<strong>Optimization:</strong> Iki haftada bir optimization, haftalık monitoring",
        "<strong>Remarketing:</strong> Temel remarketing kampanyaları",
        "<strong>Reporting:</strong> Haftalık özet + aylık detaylı rapor",
        "<strong>İletişim:</strong> Email + telefon, 24 saat response time",
        "<strong>Süre:</strong> Minimum 6 ay sözleşme"
      ]
    },
    {
      type: "subheading",
      value: "Profesyonel Paket Detayları (75.000-150.000₺ Bütçe)"
    },
    {
      type: "list",
      items: [
        "<strong>Kurulum:</strong> Enterprise-level setup + tracking implementation",
        "<strong>Kampanya Sayısı:</strong> 5-10+ kampanya (tüm kampanya tipleri)",
        "<strong>Keyword Research:</strong> 300-1000+ anahtar kelime + sürekli expansion",
        "<strong>Ad Copy:</strong> 50+ reklam metni + sürekli A/B testing",
        "<strong>Landing Pages:</strong> CRO danışmanlığı, A/B testing",
        "<strong>Optimization:</strong> Haftalık optimization, günlük monitoring",
        "<strong>Remarketing:</strong> İleri seviye remarketing + RLSA",
        "<strong>Audience Strategy:</strong> Custom audiences, customer match, similar audiences",
        "<strong>Competitive Analysis:</strong> Rakip kampanya analizi",
        "<strong>Reporting:</strong> Custom dashboard + haftalık rapor + aylık strateji toplantısı",
        "<strong>İletişim:</strong> Dedicated account manager, 12 saat response time",
        "<strong>Süre:</strong> Minimum 6 ay sözleşme"
      ]
    },
    {
      type: "subheading",
      value: "Ek Ücretler ve Hidden Costs"
    },
    {
      type: "list",
      items: [
        "<strong>Setup/Onboarding Fee:</strong> 5.000₺-15.000₺ (tek seferlik)",
        "<strong>Landing Page Design:</strong> 10.000₺-50.000₺ (özel tasarım)",
        "<strong>Video Production:</strong> 15.000₺-100.000₺ (YouTube Ads için)",
        "<strong>Graphic Design:</strong> 2.000₺-5.000₺/ay (banner, display ads)",
        "<strong>Premium Reporting:</strong> 2.000₺-5.000₺/ay (custom dashboards)",
        "<strong>Additional Channels:</strong> SEO, Social Media için %50-100 ek ücret",
        "<strong>Rush Fee:</strong> Acil projeler için %20-30 ek ücret"
      ]
    },
    {
      type: "paragraph",
      value: "<strong>Ücretlendirme Modelleri:</strong> Ajanslar genellikle 3 farklı model kullanır:"
    },
    {
      type: "list",
      items: [
        "<strong>1. Sabit Aylık Ücret:</strong> Bütçeden bağımsız sabit fee (küçük ajanslar)",
        "<strong>2. Yüzdesel Komisyon:</strong> Reklam bütçesinin %15-25'i (orta/büyük ajanslar)",
        "<strong>3. Hibrit Model:</strong> Düşük sabit ücret + düşük komisyon (çoğu ajans)"
      ]
    },
    { type: "heading", value: "Sözleşme Koşulları: Dikkat Edilmesi Gerekenler", id: "sozlesme-kosullari" },
    {
      type: "paragraph",
      value: "Google Ads ajansı ile sözleşme imzalamadan önce mutlaka şu maddelere dikkat edin:"
    },
    {
      type: "subheading",
      value: "1. Sözleşme Süresi ve Fesih Koşulları"
    },
    {
      type: "list",
      items: [
        "<strong>Minimum Süre:</strong> 3-6 ay minimum süre makuldür (1 yıl+ uzun olabilir)",
        "<strong>Fesih Bildirimi:</strong> 30 gün önceden yazılı bildirim standart",
        "<strong>Erken Fesih Cezası:</strong> Varsa miktarı net belirtilmeli",
        "<strong>Otomatik Yenileme:</strong> Sözleşme otomatik mi yenilenir? (opt-out olmalı)",
        "<strong>Exit Stratejisi:</strong> Ayrılırken kampanyaların transferi nasıl olacak?"
      ]
    },
    {
      type: "subheading",
      value: "2. Hesap Sahipliği ve Erişim Hakları"
    },
    {
      type: "list",
      items: [
        "<strong>KIRHICI ÖNEMLI:</strong> Google Ads hesabının sahibi SİZ olmalısınız, ajans değil!",
        "<strong>Admin Access:</strong> Siz admin, ajans manager veya standard access olmalı",
        "<strong>Data Ownership:</strong> Tüm kampanya verileri ve assets size ait",
        "<strong>Transfer Rights:</strong> Sözleşme bitiminde tüm kampanyalar size devredilir",
        "<strong>Analytics Access:</strong> Google Analytics, Tag Manager gibi araçlara tam erişim"
      ]
    },
    {
      type: "subheading",
      value: "3. Performans Garantileri ve KPI'lar"
    },
    {
      type: "list",
      items: [
        "<strong>Gerçekçi Hedefler:</strong> İlk 30 gün test, 60-90 günde sonuçlar beklenir",
        "<strong>KPI'ların Tanımı:</strong> ROAS, CPA, CTR, conversion rate gibi net metrikler",
        "<strong>Performans Garantisi:</strong> Garanti veriyorlarsa şartları nelerdir?",
        "<strong>Yetersiz Performans:</strong> Hedeflere ulaşılmazsa ne olur?",
        "<strong>Benchmark:</strong> Sektör ortalamaları ile karşılaştırma yapılıyor mu?"
      ]
    },
    {
      type: "paragraph",
      value: "<strong>UYARI:</strong> '1. aydan itibaren %500 ROAS garantisi' gibi abartılı vaatlere inanmayın. Gerçekçi hedefler: İlk ay test, 2-3. ayda %150-250 ROAS, 6+ ayda %300-500 ROAS."
    },
    {
      type: "subheading",
      value: "4. Hizmet Kapsamı ve Limitler"
    },
    {
      type: "list",
      items: [
        "<strong>Kampanya Sayısı:</strong> Kaç kampanya dahil? Ek kampanya için extra ücret var mı?",
        "<strong>Ad Copy Limits:</strong> Aylık kaç reklam metni yazımı dahil?",
        "<strong>Landing Page:</strong> Kaç landing page dahil? Tasarım dahil mi?",
        "<strong>Reporting:</strong> Hangi raporlar dahil? Custom reports için ek ücret?",
        "<strong>Toplantı Sıklığı:</strong> Kaç toplantı dahil? (aylık 1-4 arası normal)",
        "<strong>Support Hours:</strong> Destek saatleri nedir? (iş saatleri vs 7/24)"
      ]
    },
    {
      type: "subheading",
      value: "5. Ödeme Koşulları"
    },
    {
      type: "list",
      items: [
        "<strong>Ödeme Planı:</strong> Aylık mı peşin mi? (aylık normal)",
        "<strong>Fatura Kesim:</strong> Ayın hangi günü kesilir?",
        "<strong>Gecikme Faizi:</strong> Geç ödemelerde ceza var mı?",
        "<strong>Reklam Bütçesi:</strong> Reklam bütçesi direkt Google'a mı sizden mi ödeniyor?",
        "<strong>Refund Policy:</strong> Hizmetten memnun kalmazsanız para iadesi var mı?"
      ]
    },
    {
      type: "paragraph",
      value: "<strong>UYARI:</strong> Reklam bütçesini ajansa ödeyip, ajansın kendi hesabından kampanya yürütmesine izin vermeyin! Reklam bütçesi SİZİN hesabınızdan, SİZİN kredi kartınızdan Google'a ödenmelidir."
    },
    {
      type: "subheading",
      value: "6. Gizlilik ve Rekabet Yasağı"
    },
    {
      type: "list",
      items: [
        "<strong>NDA (Non-Disclosure Agreement):</strong> İşletme bilgilerinizin gizliliği garanti altında mı?",
        "<strong>Rekabet Yasağı:</strong> Ajans sizin doğrudan rakibinizle çalışıyor mu?",
        "<strong>Data Privacy:</strong> Müşteri verileriniz nasıl korunuyor? (KVKK, GDPR uyumu)",
        "<strong>Conflict of Interest:</strong> Ajansın başka çıkar çatışması var mı?"
      ]
    },
    { type: "heading", value: "ROI Beklentileri ve Gerçekçi Performans Hedefleri", id: "roi-beklentisi" },
    {
      type: "paragraph",
      value: "<a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">Google Reklam Ajansı</a> göre gerçekçi ROI beklentileri ve performans timeline'ı:"
    },
    {
      type: "table",
      caption: "Google Ads Performans Timeline ve ROI Beklentileri",
      headers: ["Dönem", "Beklenen Performans", "ROAS Hedefi", "Optimizasyon Aktiviteleri"],
      rows: [
        [
          "<strong>İlk 30 Gün (Test)</strong>",
          "Veri toplama, initial learnings",
          "Break-even (1x-1.5x ROAS)",
          "Kampanya kurulum, keyword testing, ad copy testing"
        ],
        [
          "<strong>30-60 Gün</strong>",
          "İlk optimizasyonlar sonuç veriyor",
          "1.5x-2.5x ROAS",
          "Kötü performans gösterenlerin durdurulması, budget reallocation"
        ],
        [
          "<strong>60-90 Gün</strong>",
          "Stable performance başlıyor",
          "2x-3.5x ROAS",
          "Remarketing ekleme, audience expansion, CRO başlangıcı"
        ],
        [
          "<strong>3-6 Ay</strong>",
          "Optimized performance",
          "3x-5x ROAS",
          "İleri seviye optimizasyon, scaling, yeni kampanya tipleri"
        ],
        [
          "<strong>6-12 Ay</strong>",
          "Mature, optimized campaigns",
          "4x-6x+ ROAS",
          "Sürekli iyileştirme, innovation, competitive strategies"
        ]
      ]
    },
    {
      type: "subheading",
      value: "Sektöre Göre Gerçekçi ROAS Beklentileri"
    },
    {
      type: "table",
      caption: "Sektörlere Göre Ortalama ROAS (6+ Ay Sonra)",
      headers: ["Sektör", "Ortalama ROAS", "İyi ROAS", "Mükemmel ROAS"],
      rows: [
        ["<strong>E-ticaret</strong>", "3x-4x", "5x-7x", "8x+"],
        ["<strong>B2B Services</strong>", "4x-6x", "7x-10x", "12x+"],
        ["<strong>SaaS</strong>", "2x-3x", "4x-5x", "6x+"],
        ["<strong>Healthcare</strong>", "5x-8x", "9x-12x", "15x+"],
        ["<strong>Legal Services</strong>", "4x-7x", "8x-12x", "15x+"],
        ["<strong>Real Estate</strong>", "3x-5x", "6x-9x", "10x+"],
        ["<strong>Home Services</strong>", "5x-8x", "9x-15x", "20x+"],
        ["<strong>Education</strong>", "3x-5x", "6x-8x", "10x+"]
      ]
    },
    {
      type: "paragraph",
      value: "<strong>Önemli Not:</strong> Bu rakamlar 6+ ay optimize edilmiş kampanyalar içindir. İlk 3 ayda bu rakamlara ulaşmak zordur. Ayrıca lifetime value (LTV) yüksek sektörlerde initial ROAS düşük olabilir ama long-term karlılık yüksektir."
    },
    {
      type: "subheading",
      value: "Performans Metriklerinde Sağlıklı Benchmarklar"
    },
    {
      type: "list",
      items: [
        "<strong>Click-Through Rate (CTR):</strong> Search: %3-5+, Display: %0.5-1%, Shopping: %0.5-1%",
        "<strong>Conversion Rate:</strong> E-ticaret: %2-4%, B2B Lead Gen: %5-10%, Services: %3-8%",
        "<strong>Cost Per Click (CPC):</strong> Sektöre göre çok değişken (2₺-50₺ arası)",
        "<strong>Quality Score:</strong> Ortalama 7-8, hedef 8-10",
        "<strong>Impression Share:</strong> %60-80+ (competitive sektörlerde %40-60 normal)",
        "<strong>Return on Ad Spend (ROAS):</strong> Minimum 3x, hedef 5x+ (6+ ay sonra)"
      ]
    },
    { type: "heading", value: "Kaçınılması Gereken Tehlikeli Ajans Profilleri", id: "tehlikeli-ajanslar" },
    {
      type: "paragraph",
      value: "<a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">18 yıldır gördüğüm</a> kötü ajans örneklerinden öğrenerek, bu red flag'lerden kaçının:"
    },
    {
      type: "subheading",
      value: "🚩 Red Flag #1: Garantili Sonuç Vaatleri"
    },
    {
      type: "list",
      items: [
        "❌ '1. aydan %500 ROAS garanti ediyoruz'",
        "❌ '3 ayda bütçenizi 10x'liyoruz'",
        "❌ 'Kesinlikle ilk sayfada olacaksınız' (SEO ile karıştırma)",
        "✅ Gerçekçi beklentiler: 'Ortalama 3-6 ayda %300-500 ROI hedefliyoruz'"
      ]
    },
    {
      type: "subheading",
      value: "🚩 Red Flag #2: Hesap Sahipliği Sorunu"
    },
    {
      type: "list",
      items: [
        "❌ 'Google Ads hesabını biz kendi hesabımızdan açacağız'",
        "❌ 'Admin erişimi vermeyiz, sizin görmenize gerek yok'",
        "❌ 'Kampanyaları kendi MCC hesabımızda yönetiyoruz'",
        "✅ Doğru yaklaşım: 'Hesap sizin, size admin erişimi vereceğiz'"
      ]
    },
    {
      type: "subheading",
      value: "🚩 Red Flag #3: Uzun Süreli Bağlayıcı Sözleşmeler"
    },
    {
      type: "list",
      items: [
        "❌ '12 ay minimum sözleşme, erken fesih 50.000₺ ceza'",
        "❌ 'Otomatik yenileme, opt-out yok'",
        "❌ '6 ay önceden fesih bildirimi gerekli'",
        "✅ Makul şartlar: '3-6 ay minimum, 30 gün önceden fesih bildirimi'"
      ]
    },
    {
      type: "subheading",
      value: "🚩 Red Flag #4: Şeffaflık Eksikliği"
    },
    {
      type: "list",
      items: [
        "❌ 'Detaylı raporlama vermeyiz, sadece özet'",
        "❌ 'Ticari sır olduğu için strateji paylaşamayız'",
        "❌ 'Google Ads hesabına login vermedik, sadece raporları paylaşırız'",
        "✅ Şeffaf ajans: 'Tüm kampanya detaylarını görebilir, istediğiniz zaman erişebilirsiniz'"
      ]
    },
    {
      type: "subheading",
      value: "🚩 Red Flag #5: Düşük Fiyat Tuzağı"
    },
    {
      type: "list",
      items: [
        "❌ '30.000₺ bütçe için sadece 3.000₺ yönetim ücreti' (çok düşük)",
        "❌ Hidden costs: Setup fee, reporting fee, optimization fee ayrı ayrı",
        "❌ Junior ekip veya outsourcing kullanımı",
        "✅ Makul fiyat: Bütçenin %15-25'i arası yönetim ücreti normal"
      ]
    },
    {
      type: "subheading",
      value: "🚩 Red Flag #6: Google Partner Badge Olmadan Partner İddiası"
    },
    {
      type: "list",
      items: [
        "❌ 'Google Partner'ız' diyorlar ama badge yok",
        "❌ 'Google ile çalışıyoruz' (herkes çalışır, partner farklı)",
        "✅ Doğrulama: Google Partners directory'den kontrol edin"
      ]
    },
    { type: "heading", value: "Ajans ile Çalışmaya Başlama Süreci", id: "baslangic-sureci" },
    {
      type: "subheading",
      value: "Adım 1: İlk İletişim ve Brief (Gün 1-3)"
    },
    {
      type: "list",
      items: [
        "İşletme bilgilerinizi paylaşın (sektör, ürün/hizmet, hedef kitle)",
        "Mevcut durum: Geçmiş kampanya verileri varsa paylaşın",
        "Hedeflerinizi belirleyin (lead sayısı, satış, ROAS beklentisi)",
        "Bütçenizi netleştirin (aylık reklam + yönetim bütçesi)",
        "Timeline: Ne kadar sürede sonuç bekliyorsunuz?"
      ]
    },
    {
      type: "subheading",
      value: "Adım 2: Teklif ve Audit Süreci (Gün 3-7)"
    },
    {
      type: "list",
      items: [
        "Ajans mevcut hesabınızı audit eder (varsa)",
        "Rakip analizi yapar",
        "Keyword opportunity analizi",
        "Preliminary strateji önerisi sunar",
        "Detaylı fiyat teklifi ve hizmet kapsamı",
        "Case study ve referanslar paylaşır"
      ]
    },
    {
      type: "subheading",
      value: "Adım 3: Sözleşme ve Onboarding (Gün 7-14)"
    },
    {
      type: "list",
      items: [
        "Sözleşme gözden geçirme (yukarıdaki kriterlere göre)",
        "Hesap erişimlerinin verilmesi (Google Ads, Analytics)",
        "Kickoff meeting: Strateji, timeline, KPI'lar",
        "Tracking setup: Conversion tracking, GA4, GTM",
        "İlk kampanya planlaması"
      ]
    },
    {
      type: "subheading",
      value: "Adım 4: İlk 30 Gün (Test ve Learning)"
    },
    {
      type: "list",
      items: [
        "<strong>Gün 1-7:</strong> Kampanya kurulumu, keyword research, ad copy yazımı",
        "<strong>Gün 7-14:</strong> Kampanya launch, initial data collection",
        "<strong>Gün 14-21:</strong> İlk optimizasyonlar (kötü performans gösterenleri durdurma)",
        "<strong>Gün 21-30:</strong> Haftalık toplantı, ilk insights, strateji ayarlamaları"
      ]
    },
    {
      type: "subheading",
      value: "Adım 5: Sürekli Optimizasyon ve Raporlama (30+ Gün)"
    },
    {
      type: "list",
      items: [
        "Haftalık/aylık periyodik toplantılar",
        "Sürekli A/B testing ve optimizasyon",
        "Performans raporlarının incelenmesi",
        "Strateji ayarlamaları ve yeni kampanya tipleri",
        "ROI ve KPI takibi"
      ]
    },
    {
      type: "paragraph",
      value: "<strong>Sonuç:</strong> Doğru Google Ads reklam ajansı seçimi, dijital pazarlama yatırımınızın geri dönüşünü doğrudan etkiler. <a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">Dijital Mustafa</a> hem ajans hem de bireysel danışmanlık perspektifinden, size en uygun çözümü bulmak için profesyonel destek sunuyorum."
    },
    {
      type: "paragraph",
      value: "İlgili kaynaklar: <a href=\"/blog/google-reklam-ajansi\" class=\"text-[#059669] hover:underline\">Google reklam ajansı karşılaştırması</a>, <a href=\"https://www.google.com/partners/\" rel=\"nofollow\" target=\"_blank\" class=\"text-[#059669] hover:underline\">Google Partners</a>, <a href=\"https://support.google.com/google-ads\" rel=\"nofollow\" target=\"_blank\" class=\"text-[#059669] hover:underline\">Google Ads Destek Merkezi</a> ve <a href=\"https://skillshop.withgoogle.com\" rel=\"nofollow\" target=\"_blank\" class=\"text-[#059669] hover:underline\">Google Skillshop Eğitimleri</a>."
    },
    { type: "heading", value: "Sık Sorulan Sorular", id: "sss" },
    {
      type: "subheading",
      value: "Google Partner ajansı seçmek zorunlu mu?"
    },
    {
      type: "paragraph",
      value: "Zorunlu değil ama önerilir. Google Partner statüsü, ajansın belirli standartları karşıladığını ve sürekli eğitim aldığını gösterir. Ancak sertifika tek başına yeterli değildir."
    },
    {
      type: "subheading",
      value: "Ajans minimum hangi bütçeyle çalışır?"
    },
    {
      type: "paragraph",
      value: "Çoğu ajans minimum 30.000-50.000₺ aylık reklam bütçesi ister. Daha düşük bütçeler için bireysel uzman daha uygun maliyetli olabilir."
    },
    {
      type: "subheading",
      value: "İlk sonuçları ne kadar sürede alırım?"
    },
    {
      type: "paragraph",
      value: "İlk tıklamalar 1-2 günde başlar ancak optimize edilmiş sonuçlar 60-90 gün içinde görülür. İlk 30 gün öğrenme ve test dönemidir, sabırlı olun."
    }
  ]
};

export default googleAdsReklamAjansiContent;
